import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { isGamePath, seoLinks } from '@/lib/seo'

/** Crea (se manca) e aggiorna un `<meta>` del documento, cercandolo per `name` o `property`. */
function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  element.content = content
}

/**
 * Titolo, descrizione, canonical, `hreflang` e Open Graph della pagina pubblica corrente ("zambe laureato" sempre presente).
 * Google esegue il JavaScript: index.html ha già i valori della home per chi non lo esegue.
 */
export function Seo() {
  const { t, i18n } = useTranslation()
  const { pathname } = useLocation()

  useEffect(() => {
    const key = isGamePath(pathname) ? 'seo.games' : 'seo.home'
    const title = t(`${key}.title`)
    const description = t(`${key}.description`)
    const { canonical, alternates } = seoLinks(pathname)

    document.title = title
    setMeta('name', 'description', description)
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:url', canonical)
    setMeta('property', 'og:locale', i18n.language === 'en' ? 'en_GB' : 'it_IT')

    document.head.querySelectorAll('link[rel="canonical"], link[rel="alternate"][hreflang]').forEach((link) => link.remove())
    const canonicalLink = document.createElement('link')
    canonicalLink.rel = 'canonical'
    canonicalLink.href = canonical
    document.head.appendChild(canonicalLink)
    for (const { hreflang, href } of alternates) {
      const link = document.createElement('link')
      link.rel = 'alternate'
      link.hreflang = hreflang
      link.href = href
      document.head.appendChild(link)
    }
  }, [pathname, i18n.language, t])

  return null
}
